import { NextPage } from 'next'
import dynamic from 'next/dynamic'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import React from 'react'

import { getFloatingMenu } from '@/services/apps'
import { getNews } from '@/services/news'
import {
  getDetailContactList,
  getDetailImages,
  getDetailInfrastructureList,
  getDetailInvestmentsList,
  getDetailProfile,
  getDetailRegulationList,
  getDetailSezRegions,
  getDetailVideoList,
} from '@/services/sez-regions'
import { wrapper } from '@/store'

const DetailMaps = dynamic(() => import('./DetailMaps'), { ssr: false })

const Page: NextPage = () => {
  return (
    <main className='min-h-screen overflow-x-hidden bg-gray-100'>
      <DetailMaps />
    </main>
  )
}

export const getProps = wrapper.getServerSideProps((store) => async ({ locale, params }) => {
  const paramsList = {
    params: { skip: 0, limit: 1000, slug: String(params?.slug) },
    headers: { 'Accept-Language': String(locale) },
  }
  await Promise.all([
    store.dispatch(
      getDetailSezRegions.initiate({ params: { slug: paramsList.params.slug }, headers: paramsList.headers })
    ),
    store.dispatch(
      getDetailProfile.initiate({ params: { slug: paramsList.params.slug }, headers: paramsList.headers })
    ),
    store.dispatch(
      getNews.initiate({
        params: { skip: 0, limit: 1000, keyword: { slugSez: String(params?.slug) } },
        headers: paramsList.headers,
      })
    ),
    store.dispatch(getDetailImages.initiate(paramsList)),
    store.dispatch(getDetailRegulationList.initiate(paramsList)),
    store.dispatch(getDetailInfrastructureList.initiate(paramsList)),
    store.dispatch(getDetailInvestmentsList.initiate(paramsList)),
    store.dispatch(getDetailVideoList.initiate(paramsList)),
    store.dispatch(getDetailContactList.initiate(paramsList)),
    store.dispatch(getDetailContactList.initiate(paramsList)),
    store.dispatch(getFloatingMenu.initiate({ headers: { ...paramsList.headers } })),
  ])

  return {
    props: {
      ...(await serverSideTranslations(String(locale), ['common', 'investment'])),
    },
  }
})

export default Page
